<template>
  <div class="shop-about-page">
    <header class="page-header">
      <button
        type="button"
        class="back-btn"
        @click="$router.back()"
      >
        <van-icon name="arrow-left" />
      </button>
      <h1>{{ pageTitle }}</h1>
    </header>

    <main class="about-main">
      <section class="article-card">
        <div
          v-if="content"
          class="article-content"
          v-html="content"
        />
        <div
          v-else
          class="article-empty"
        >
          {{ $t('shopCenter.articleEmpty') }}
        </div>
      </section>
    </main>
  </div>
</template>

<script>
import Vue from 'vue';
import Fetch from '../../utils/fetch';
import { Icon, Toast } from 'vant';

Vue.use(Icon).use(Toast);

export default {
  name: 'ShopAbout',
  data() {
    return {
      app: {},
      title: '',
      content: '',
    };
  },
  computed: {
    pageTitle() {
      return this.title || this.$t('shopCenter.storeDescription');
    },
  },
  created() {
    if (this.$parent && this.$parent.footer) {
      this.$parent.footer('', true);
    }
  },
  mounted() {
    this.start();
  },
  methods: {
    start() {
      Fetch('/index/webconfig').then((res) => {
        this.app = res.data || {};
      });
      Fetch('/index/shop_article', {}, null, true).then((res) => {
        var data = res.data || {};
        this.title = data.title || '';
        this.content = data.content || '';
      }).catch(() => {
        Toast(this.$t('shopCenter.articleEmpty'));
      });
    },
    kefuTo() {
      if (this.app && this.app.kefu_link) {
        window.location.href = this.app.kefu_link;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.shop-about-page {
  min-height: 100vh;
  padding-bottom: 78px;
  background: #f2f2f4;
  color: #06152e;
}

.page-header {
  position: relative;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f5f6fb;
  border-bottom: 1px solid #e8ebf0;
}

.page-header h1 {
  margin: 0;
  max-width: 240px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 14px;
  line-height: 20px;
  font-weight: 500;
}

.back-btn {
  position: absolute;
  left: 18px;
  top: 0;
  width: 46px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  border: 0;
  padding: 0;
  background: transparent;
  color: #06152e;
}

.back-btn .van-icon {
  font-size: 22px;
}

.about-main {
  padding: 6px;
}

.article-card {
  min-height: calc(100vh - 178px);
  padding: 18px 16px;
  border-radius: 10px;
  background: #fff;
  box-sizing: border-box;
}

.article-content {
  color: #06152e;
  font-size: 14px;
  line-height: 24px;
  word-break: break-word;
}

.article-content /deep/ p {
  margin: 0 0 10px;
}

.article-content /deep/ img {
  max-width: 100%;
  height: auto;
}

.article-empty {
  padding-top: 110px;
  color: #9aa3af;
  text-align: center;
  font-size: 12px;
  line-height: 18px;
}

.kefu {
  position: fixed;
  right: 26px;
  bottom: 100px;
  z-index: 12;
  width: 66px;
  height: 66px;
  border-radius: 50%;
  overflow: hidden;
  border: 4px solid #fff;
  background: linear-gradient(180deg, #1884ff 0%, #1884ff 68%, #f70720 68%, #f70720 100%);
  box-shadow: 0 4px 14px rgba(0, 0, 0, .22);
  box-sizing: border-box;
}

.kefu_img {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
}

.kefu_img .van-icon {
  font-size: 36px;
}
</style>
